import { LandingSectionEyebrow } from '@/components/landing/landing-section-eyebrow'
import {
  LANDING_PILLARS,
  LANDING_PILLARS_SECTION,
  LANDING_SECTION_GRADIENT,
} from '@/lib/landing-content'
import { ArrowRight } from 'lucide-react'
import type React from 'react'

type LandingPillarsSectionProps = {
  onScrollToSection: (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => void
}

export function LandingPillarsSection({ onScrollToSection }: LandingPillarsSectionProps) {
  return (
    <section
      id="what-is-pelgo"
      className="py-12 md:py-32 scroll-fade-up"
      style={{ backgroundImage: LANDING_SECTION_GRADIENT }}
    >
      <div className="container mx-auto px-4 md:px-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="mb-10 md:mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
            <div className="flex-1">
              <LandingSectionEyebrow label={LANDING_PILLARS_SECTION.eyebrow} className="mb-4" />
              <div className="flex flex-col gap-1">
                <h2 className="text-3xl md:text-[48px] font-display text-gray-900 leading-[1.2] tracking-[-0.96px]">
                  {LANDING_PILLARS_SECTION.title}
                </h2>
                <p className="text-3xl md:text-[48px] font-display text-gray-400 leading-[1.2] tracking-[-0.96px]">
                  {LANDING_PILLARS_SECTION.titleMuted}
                </p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 md:gap-16 md:items-stretch">
            {LANDING_PILLARS.map((pillar) => (
              <div key={pillar.title} className="flex flex-col h-full gap-10 md:gap-0">
                <div className="flex flex-col gap-4">
                  <div className="flex flex-col gap-2">
                    <h3 className="text-lg font-medium text-gray-900 tracking-[-0.36px]">
                      {pillar.title}
                    </h3>
                    <p className="text-base font-medium text-gray-500 tracking-[-0.32px]">
                      {pillar.description}
                    </p>
                  </div>
                  <a
                    href={`#${pillar.scrollTargetId}`}
                    onClick={(e) => onScrollToSection(e, pillar.scrollTargetId)}
                    className="inline-flex items-center gap-2 text-sm font-semibold text-pelgo-blue-light hover:text-pelgo-blue-light/80 transition-colors w-fit"
                  >
                    Learn More
                    <ArrowRight className="h-4 w-4" />
                  </a>
                </div>
                <div className="md:mt-auto md:pt-8">
                  <div className="rounded-2xl overflow-hidden aspect-[4/3]">
                    <img
                      src={pillar.imageSrc}
                      alt={pillar.imageAlt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
